import React, { FC, memo, useState, useEffect } from "../../../../lib/teact/teact";
import { LotScreenSettings } from "../../config/uiconfig";
import store from "../../store";
import Loading from "../../ui/loading";
import { GetUserFullInfo, isCuPhapMb, isCuPhapMn } from "../../utils/common";
import { getSMSMau5_1MienTay } from "../templete/reportMienTayMau5_1";
import MessageView from "./messageView";
import { buildReportHtmlDocument, buildReportMessageMetaHtml } from "./reportHtmlDocument";
import { buildTotalReportHtml, buildTotalReportViewModel, renderTotalReportTable } from "./totalReportRenderUtils";
import './totalReportByMessage.scss'

type OwerProp = {
    data: any;
    id?: string;
    key: string;
    messageIndex: number;
    onChangeViewType: (viewType: string, index: number) => void;
    onRemoveItem: (index: number) => void;
    onReloadItem: (index: number) => void;
    hideToolbar?: boolean;
    onChangeScreen: (prevScreen: LotScreenSettings) => void;
    soTin: number;
    hilight?: string;
    totalDisplayTemplete?: 0 | 1 | 2 | 3 | 4 | 5 | 6 | 7 | 8 | 9 | undefined; // dùng để chọn mẫu báo cáo hiển thị
}

type ExportHtmlOptions = {
    totalDisplayTemplete?: 0 | 1 | 2 | 3 | 4 | 5 | 6 | 7 | 8 | 9 | undefined;
    showDetails?: boolean;
    renderTienCo?: boolean;
    wrapDocument?: boolean;
};

export function getTotalReportDisplayHtml(data: any, options?: ExportHtmlOptions): string {
    const totalDisplayTemplete = options?.totalDisplayTemplete;
    const messageMetaHtml = buildReportMessageMetaHtml(data);
    const wrapDocument = options?.wrapDocument ?? true;
    if (totalDisplayTemplete != undefined && totalDisplayTemplete == 6) {
        const html = getSMSMau5_1MienTay(data, false, true);
        const fragment = `${messageMetaHtml}${String(html)}`;
        return wrapDocument ? buildReportHtmlDocument(String(html), "Total Report", messageMetaHtml) : fragment;
    }
    const viewModel = buildTotalReportViewModel(data, {
        showDetails: options?.showDetails ?? false,
        renderTienCo: options?.renderTienCo ?? false,
        isCuPhapMn: isCuPhapMn(),
        isCuPhapMb: isCuPhapMb(),
    });
    const reportHtml = buildTotalReportHtml(viewModel);
    const fragment = `${messageMetaHtml}${reportHtml}`;
    return wrapDocument ? buildReportHtmlDocument(reportHtml, "Total Report", messageMetaHtml) : fragment;
}

const TotalReportByMessage: FC<OwerProp> = ({
    data,
    id,
    key,
    onChangeViewType,
    messageIndex,
    onRemoveItem,
    onReloadItem,
    hideToolbar,
    onChangeScreen,
    soTin,
    hilight,
    totalDisplayTemplete,
}) => {

    const user: any = GetUserFullInfo()
    const [state, setState] = useState({
        showDetails: false,
        isItemReloading: store.getState().basicReport.isItemReloading,
        isCurrent: false,
        renderTienCo: user.tinhId == "BTH",
    })

    function handleRemoveItem(index: number) {
        if (onRemoveItem)
            onRemoveItem(index)
    }
    useEffect(() => {
        const unsubsribe = store.subscribe(() => {
            const isLoading = store.getState().basicReport.isItemReloading

            setState(prev => ({ ...prev, isItemReloading: isLoading }))
            if (!isLoading)
                setState(prev => ({ ...prev, isCurrent: false }))

        })
        return unsubsribe;
    }, [])
    function handleReloadItem(index: number) {
        setState(prev => ({ ...prev, isCurrent: true }))
        onReloadItem(index)
    }
    function IsRenderTienCo(): boolean {
        return state.renderTienCo;
    }
    function handleChangeRenderType(e: any) {
        const oldType = state.renderTienCo
        setState(prev => ({ ...prev, renderTienCo: !oldType }))
        e.stopPropagation()
    }
    const renderTotalReport = () => {
        if (totalDisplayTemplete != undefined && totalDisplayTemplete == 6) {
            return getSMSMau5_1MienTay(data, true)
        } else {
            const viewModel = buildTotalReportViewModel(data, {
                showDetails: state.showDetails,
                renderTienCo: IsRenderTienCo(),
                isCuPhapMn: isCuPhapMn(),
                isCuPhapMb: isCuPhapMb(),
            });
            return renderTotalReportTable(viewModel, handleChangeRenderType)
        }
    }
    return (
        <div className="card-container"
            onClick={(e) => {
                //if (e.target == e.currentTarget) {
                console.log('container clicked')
                setState(prev => ({ ...prev, showDetails: !state.showDetails }))
                e.stopPropagation()
                //}
            }}

        >
            <MessageView data={data} messageIndex={messageIndex}
                onChangeViewType={onChangeViewType}
                onRemoveItem={handleRemoveItem}
                onReloadItem={handleReloadItem}
                hideToolbar={hideToolbar}
                onChangeScreen={onChangeScreen}
                soTin={soTin}
                hilight={hilight}
            />
            {(state.isItemReloading && state.isCurrent) ? <div key={"item-loading"} className=" table-container"><Loading /></div>
                :
                <div key={key} id={id} className=" table-container" >

                    {renderTotalReport()}

                </div>
            }
        </div >
    )
}

export default memo(TotalReportByMessage)